import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=1f9db722&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=1f9db722&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9db722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9db722')) {
      api.createRecord('1f9db722', component.options)
    } else {
      api.reload('1f9db722', component.options)
    }
    module.hot.accept("./orderSend.vue?vue&type=template&id=1f9db722&scoped=true", function () {
      api.rerender('1f9db722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/orderSend.vue"
export default component.exports